import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductSelectionService } from '../../../../../../../core/services/product-selection.service';
import {
  WashSummary,
  WASH_SUMMARY,
} from '../../../../../../../core/utils/wash-texts';
import { SummaryService } from '../../../../../../../core/services/summary.service';
import { ISummaryData } from '../../../../../../../core/models/summary-data';
import { CatalogService } from '../../../../../../../core/services/catalog.service';

@Component({
  selector: 'app-wash',
  standalone: false,
  templateUrl: './wash.component.html',
  styleUrl: './wash.component.scss',
})
export class WashComponent {
  selectedItem: any;
  selectedItemCards: any;
  selectedWashType: any = null;
  resumeSelected: WashSummary | null = null;
  summaryData: ISummaryData = {} as ISummaryData;

  constructor(
    private router: Router,
    private productService: ProductSelectionService,
    private summaryService: SummaryService,
    private catalogDataService: CatalogService
  ) {
    this.selectedItem =
      this.router.getCurrentNavigation()?.extras.state?.['selectedItem'];
    this.selectedItemCards = this.selectedItem?.relatedCards;
    console.log('Selected item:', this.selectedItem);
    console.log('Selected item cards:', this.selectedItemCards);

    const stored = this.summaryService.getSummary();
    if (stored) {
      this.summaryData = stored;
    } else {
      const local = localStorage.getItem('summaryData');
      if (local) {
        this.summaryData = JSON.parse(local);
        this.summaryService.setSummary(this.summaryData);
      } else {
        this.summaryData = {
          productInformation: {},
        };
      }
    }
  }

  ngOnInit() {
    const selected = this.productService.getProduct();
    this.selectedItem = selected;
    this.selectedItemCards = selected?.relatedCards;
  }

  selectService(item: any) {
    this.selectedWashType = item;
    const tipo = item.title?.toLowerCase();
    console.log('Tipo de lavado seleccionado:', tipo);
    this.resumeSelected = WASH_SUMMARY[tipo];

    const selected = item;
    const taxRate = 0.21;

    const price = selected.Price ?? 0;
    const caflerFee = selected.CaflerFee ?? 0;
    const subtotal = price + caflerFee;
    const taxAmount = subtotal * taxRate;
    const total = subtotal + taxAmount;

    this.summaryData = {
      ...this.summaryData,
      productInformation: {
        ZoneId: this.summaryData.productInformation?.ZoneId,
        FinishZoneId: this.summaryData.productInformation?.FinishZoneId,
        icon: selected.icon,
        product: {
          ...selected,
          productId: selected.Id,
        },
      },
      TotalOrderAmount: parseFloat(total.toFixed(2)),
      TotalOrderTaxAmount: parseFloat(taxAmount.toFixed(2)),
    };

    this.summaryService.setSummary(this.summaryData);
    console.log('summaryData', this.summaryData);
  }

  back() {
    this.selectedWashType = null;
    this.resumeSelected = null;
  }

  submitForm(): void {
    this.summaryData = {
      ...this.summaryData,
      productInformation: {
        ZoneId: this.summaryData.productInformation?.ZoneId,
        FinishZoneId: this.summaryData.productInformation?.FinishZoneId,
        icon: this.selectedItem.icon,
        product: this.selectedWashType,
      },
      serviceConfiguration: {},
    };

    this.summaryService.setSummary(this.summaryData);
    this.catalogDataService.emitProductInfo(this.summaryData);
    localStorage.setItem(
      'subSelectedProduct',
      JSON.stringify(this.selectedWashType)
    );
  }
}
